export default __webpack_public_path__ + "static/afternoon-0541dac34ae8c72f8e16bbc91ccb3abc.webp";